import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const regimeConditionData = api(async function regimeConditionData(params) {
    const regimeId = params?.regimeId
    if (!regimeId) return null
    return query(
        gql`
            query GetRegimeConditionData($regimeId: String!) {
                regimeConditionData(regimeId: $regimeId) {
                    facilities
                    towns
                    postcodes
                    assetTypes
                    regimeFields {
                        field
                        label
                        values
                    }
                    assetRegisterFields {
                        field
                        label
                        values
                        isCustom
                    }
                }
            }
        `,
        { regimeId },
        { returns: "regimeConditionData" }
    )
})
